import React from 'react';

const MAP: Record<string, { cls: string; label: string }> = {
  COMPLIANT: { cls: 'pill-compliant', label: 'Compliant' },
  NON_COMPLIANT: { cls: 'pill-non-compliant', label: 'Non-Compliant' },
  EXEMPT: { cls: 'pill-exempt', label: 'Exempt' },
  PENDING_REVIEW: { cls: 'pill-pending', label: 'Pending Review' },
  INCOMPLETE: { cls: 'pill-non-compliant', label: 'Incomplete' },
};

const StatusPill: React.FC<{ status: string }> = ({ status }) => {
  const entry = MAP[status] || { cls: 'pill-pending', label: status };
  return <span className={`pill ${entry.cls}`}>{entry.label}</span>;
};

export default StatusPill;
